import { render, staticRenderFns } from "./fu-input-button.vue?vue&type=template&id=4d40ea4e&scoped=true"
import script from "./fu-input-button.vue?vue&type=script&lang=js"
export * from "./fu-input-button.vue?vue&type=script&lang=js"
import style0 from "./fu-input-button.vue?vue&type=style&index=0&id=4d40ea4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40ea4e",
  null
  
)

export default component.exports